import React from 'react'
import FullHeight from 'react-full-height'

import { Grid, Typography, Box, Button } from '@mui/material'

import MacbookXs from '../MacbookXs'
import IphoneXs from '../IphoneXs'
import MacbookMd from '../MacbookMd'
import IphoneMd from '../IphoneMd'

import "@fontsource/rajdhani"
import "@fontsource/mukta"
import "@fontsource/fredoka-one"
const Section1 = () => {
  return (
   
    <div>
    <Box sx={{display:{xs:"none",md:"block"}}}>
        <FullHeight >
            <Grid container sx={{mt:15}} style={{height:"80vh",textAlign:"center"}}>
            <Grid item xs={4} >
              <MacbookMd/>
            </Grid>
            <Grid item xs={4} >
            <Box sx={{p:5,mt:1,background:"white",border:1,borderRadius:2}}>  
              <Typography variant="p" style={{fontFamily: 'Rajdhani',fontWeight:"800"}}>Welcome to TIE,</Typography>
              <Typography variant="h3" style={{fontFamily:"Fredoka One"}}>Tech It Easy</Typography>  
              <Typography sx={{mt:2,px:3,fontFamily:"Mukta"}}>The art of website creation often seems more difficult to most of the population than it has to be, it's all about your approach. At TIE we try to walk with our clients, holding their hand through every step of the way to ensure that we extract their ideal websites from their imagination and turn it into reality.</Typography>
              <Button variant="contained" sx={{mt:2}} style={{background:"black"}}><a style={{textDecoration:"none",color:"inherit"}} href="#whyus">Why Us?</a></Button>
            </Box>
            </Grid>
            <Grid item xs={4} >
            <Box item xs={4} style={{height:"80vh"}}>
              <IphoneMd/>
            </Box>
            </Grid>
            </Grid>
          
        </FullHeight>
        </Box>
        <Box sx={{display:{xs:"block",md:"none"}}}>
          <Grid container sx={{mt:10}} style={{textAlign:"center"}}>
            <Grid item xs={12} >
            <Box sx={{p:5,mt:1,mx:2,background:"white",border:1,borderRadius:2}}>  
              <Typography variant="p" style={{fontFamily: 'Rajdhani',fontWeight:"800"}}>Welcome to TIE,</Typography>
              <Typography variant="h3" style={{fontFamily:"Fredoka One"}}>Tech It Easy</Typography>  
              <Typography sx={{mt:2,px:3}} style={{fontFamily:"Mukta"}}>The art of website creation often seems more difficult to most of the population than it has to be, it's all about your approach. At TIE we try to walk with our clients, holding their hand through every step of the way to ensure that we extract their ideal websites from their imagination and turn it into reality.</Typography>
              <Button variant="contained" sx={{mt:2}} style={{background:"black"}}><a style={{textDecoration:"none",color:"inherit"}} href="#whyus">Why Us?</a></Button>
            </Box>
            </Grid>
            <Grid item xs={5.6} >
              <MacbookXs/>
            </Grid>
            <Grid item xs={5.6} >
              <Box style={{height:"50vh"}}>
                <IphoneXs/>
              </Box>
            </Grid>
            </Grid>
          </Box>
    </div>
  )
}

export default Section1